import { AppDispatch, RootState } from '..';
import { onAddingOrder, setAllOrders } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import { notification } from '../../utils';
import { productPurchaseType } from '../../types';

export const getProductPurchases = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const  { company_id } = company;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/product-purchase/company/${company_id}`, headers(token));

    const { products } = data;

    try {

        dispatch(setAllOrders(products));
        
    } catch (error: any) {
        console.log(error?.message);
    }
};

export const makeProductPurchase = (values: productPurchaseType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingOrder(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const { company_id }: any = company;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/product-purchase/add`, { ...values, company_id }, headers(token));

    const { success, message } = data;

    try {

        dispatch(onAddingOrder(false));
        notification(success ? 'success' : 'error', message);
        
    } catch (error: any) {

        dispatch(onAddingOrder(false));
        notification(success ? 'success' : 'error', error.message);

    }
};